export default __webpack_public_path__ + "static/media/portfolio-hover-192.5b33a351.jpg";